<template>
  <div class="ml-container">
    <div
      class="ml-item"
      :class="{
        'item-text': item.type == 'text',
        'item-line': item.type == 'line',
        'item-none': item.type == 'none',
        'item-last': item.last
      }"
      :style="{ width: width + 'px' }"
      v-for="(item, index) in mlList"
      :key="index"
    >
      <div class="text">{{ item.text }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 20
    },
    /* 容器最大容量 */
    max: {
      type: Number,
      default: 2200,
      // 自定义校验
      validator: function (val) {
        return val % 1 === 0
      }
    },
    /* 刻度尺最大标到的容量 */
    limit: {
      type: Number,
      default: 2200,
      // 自定义校验
      validator: function (val) {
        return val % 1 === 0
      }
    },
    /* 最小容量 */
    min: {
      type: Number,
      default: 0,
      // 自定义校验
      validator: function (val) {
        return val % 1 === 0
      }
    },
    unit: {
      type: String,
      default: 'ML'
    },
    unitNum: {
      type: Number,
      default: 100,
      // 自定义校验
      validator: function (val) {
        return val % 1 === 0
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    mlList() {
      let res = []
      let curNum = this.min
      while (curNum <= this.max) {
        let istext =
          (curNum % (this.unitNum * 10) === 0 &&
            curNum != 0 &&
            curNum <= this.limit) ||
          curNum == this.limit
        res.push({
          type: istext ? 'text' : curNum > this.limit ? 'none' : 'line',
          text: istext ? curNum + this.unit : '',
          last: curNum === this.limit
        })
        curNum += this.unitNum
      }
      console.log(res)
      return res
    }
  },
  created() {
    if (this.min >= this.max) {
      this.$toast('最小值不能大于最大值')
    }
  }
}
</script>
<style lang="scss" scoped>
.ml-container {
  display: inline-flex;
  justify-content: space-between;
  flex-direction: column-reverse;
  height: 100%;
  .ml-item {
  }
  .item-line {
    width: 100%;
    height: 1px;
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .item-none {
    width: 100%;
    height: 1px;
    display: inline-block;
  }
  .item-text {
    position: relative;
    height: 1px;
    font-size: 10px;
    font-family: DINCondensed-Bold, DINCondensed;
    color: rgba(0, 0, 0, 0.4);
    line-height: 12px;
    .text {
      white-space: nowrap;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 50%;
    }
  }
  .item-last {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
